import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { Action } from '../../actions';
import LocalStorageManager from '../../utils/localStorage/manager';

export enum SelectionActionKeys {
	TOGGLE_SELECTION = '@@selection/TOGGLE_SELECTION',
	LOAD_SELECTION = '@@selection/LOAD_SELECTION',
	CLEAR_SELECTION = '@@selection/CLEAR_SELECTION',
}

export type SelectionListAction =
	ToggleSelectionsAction |
	LoadSelectionAction |
	ClearSelectionAction;

interface ToggleSelectionsAction extends Action {
	type: SelectionActionKeys.TOGGLE_SELECTION;
	selectionIds: number[];
}

interface LoadSelectionAction extends Action {
	type: SelectionActionKeys.LOAD_SELECTION;
	selectionIds: number[];
}

interface ClearSelectionAction extends Action {
	type: SelectionActionKeys.CLEAR_SELECTION;
}

export const loadPreviousSelection = () => (dispatch: Dispatch<StoreState>): void => {
	const previousSelection = LocalStorageManager.getSelection();
	if (previousSelection) {
		const action: LoadSelectionAction = {
			type: SelectionActionKeys.LOAD_SELECTION,
			selectionIds: previousSelection,
		};
		dispatch(action);
	}
};

export const toggleSelection = (itemId: number) =>
	(dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {

	const { selection } = getState();
	const isInSelection = selection.includes(itemId);
	let newSelection = selection.slice(0); // copies the array

	if (isInSelection) {
		newSelection.splice(newSelection.indexOf(itemId), 1);
	} else {
		newSelection.push(itemId);
	}

	LocalStorageManager.setSelection(newSelection);

	const action: ToggleSelectionsAction = {
		type: SelectionActionKeys.TOGGLE_SELECTION,
		selectionIds: newSelection,
	};

	dispatch(action);
};

export const clearSelection = () => (dispatch: Dispatch<StoreState>, getState: () => StoreState): void => {
	LocalStorageManager.setSelection([]);
	const action: ClearSelectionAction = { type: SelectionActionKeys.CLEAR_SELECTION };
	dispatch(action);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Selection/actions.ts